let nthDomId = 0;
export function domId(prefix="id") {
  return `${prefix}-${++nthDomId}`
}

export function applyStyles(element: HTMLElement, styles: { [s: string]: unknown; }) {
  Object.entries(styles).forEach(([k, v]) => element.style[k] = `${v}`)
}

export function applyAttributes(element: HTMLElement, attrs: { [s: string]: string | { [s: string]: unknown; } | null | undefined | boolean; }) {
  for (const [name, value] of Object.entries(attrs)) {
    if (value === true) {
      element.setAttribute(name, name);
    } else if (value === null || value === false || typeof value === "undefined") {
      element.removeAttribute(name);
    } else if (name === "style" && typeof value !== 'string' && !(value instanceof String)) {
      applyStyles(element, value);
    } else {
      element.setAttribute(name, `${value}`);
    }
  }
}

export function html(tagName: string, attrs = {}, children = []) {
  const el = document.createElement(tagName);
  applyAttributes(el, attrs);
  if (children.length > 0) el.append(...children);
  return el;
}